import React, { Fragment, FunctionComponent, useEffect, useState } from 'react';
import { ApplicationState } from '../../../redux/States';
import { ErrorDispatches } from '../../../redux/Dispatches';
import { ConnectedProps, connect } from 'react-redux';
import { Cell, Row, downloadSheets, generateSheet } from '../../../utils';
import XLSX, { Range } from 'xlsx-js-style';
import {
    Dropdown,
    DropdownButton,
    Row as BSRow,
    Table,
} from 'react-bootstrap';
import { AuthedLayout } from '../../../components';
import { TeeGradeClassStatistic, UserInfo } from '../../../model';
import { useSemGrade } from '../../../hook';
import apis from '../../../apis';
import { toast } from 'react-toastify';


const borderStyle = { color: { rgb: '000000' }, style: 'thin' } as const;
const fullBorderStyle = {
    top: borderStyle,
    bottom: borderStyle,
    left: borderStyle,
    right: borderStyle,
} as const;
const cellAlignStyle = {
    horizontal: 'center',
    vertical: 'center',
} as const;

const mapState = (state: ApplicationState) => ({ ...state.auth });
const mapDispatches = ErrorDispatches;

const connector = connect(mapState, mapDispatches);

type Props = ConnectedProps<typeof connector>;

const teeStaticSexAll: FunctionComponent<Props> = ({ catchErrorForModal }) => {
    const { yearSem, element } = useSemGrade();
    const [datas, setDatas] = useState<TeeGradeClassStatistic[]>([]);
    const [userinfo, setUser] = useState<UserInfo>();
    useEffect(() => {
        if (yearSem) {
            apis.getUserInfo()
                .then((u) => {
                    setUser(u);
                })
                .catch(catchErrorForModal);

            toast
                .promise(
                    apis.getTeethTeeStaticSexAll(yearSem.year, yearSem.sem)
                        .then((r) =>
                            setDatas(r)
                        ),
                    {
                        pending: '資料載入中......',
                        success: '資料載入成功！',
                        error: '資料載入失敗！請查看錯誤資訊。',
                    }
                )
        }
    }, [yearSem?.year, yearSem?.sem]);

    const gradeBase = datas.reduce((grades, d) => {
        return { ...grades, [d.grade]: [...(grades[d.grade] || []), d] };
    }, {} as Record<number, TeeGradeClassStatistic[]>);
    const physicalGrades = Array.from(
        new Set(
            Object.values(gradeBase)
                .flat()
                .filter((item) => item.isPhysical)
                .map((item) => item.grade)
        )
    )
        .sort((a, b) => a - b);
    let schoolcount = 0;
    let schoolcountT01 = 0;
    let schoolcountT11 = 0;
    let schoolcountT12 = 0;
    let schoolcountT13 = 0;
    let schoolcountT15 = 0;
    let countRow = 0;
    const contentRows: Row[] = Object.values(gradeBase).flatMap(
        (gs, idx, allArray) => {
            const rows = gs.flatMap((g, idx) => {
                // 計算資料筆數
                countRow++;
                schoolcount += g.total?.count ?? 0;
                schoolcountT01 += g.total?.countT01 ?? 0;
                schoolcountT11 += g.total?.countT11 ?? 0;
                schoolcountT12 += g.total?.countT12 ?? 0;
                schoolcountT13 += g.total?.countT13 ?? 0;
                schoolcountT15 += g.total?.countT15 ?? 0;
                return TeeToRows(
                    g.grade,
                    g.male?.count ?? 0,
                    g.male?.countT01 ?? 0,
                    g.male?.countT11 ?? 0,
                    g.male?.countT12 ?? 0,
                    g.male?.countT13 ?? 0,
                    g.male?.countT15 ?? 0,
                    g.female?.count ?? 0,
                    g.female?.countT01 ?? 0,
                    g.female?.countT11 ?? 0,
                    g.female?.countT12 ?? 0,
                    g.female?.countT13 ?? 0,
                    g.female?.countT15 ?? 0,
                    g.total?.count ?? 0,
                    g.total?.countT01 ?? 0,
                    g.total?.countT11 ?? 0,
                    g.total?.countT12 ?? 0,
                    g.total?.countT13 ?? 0,
                    g.total?.countT15 ?? 0,
                );
            });

            if (datas.length == countRow) {
                rows.push(...TeeToRows(
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    schoolcount ?? 0,
                    schoolcountT01 ?? 0,
                    schoolcountT11 ?? 0,
                    schoolcountT12 ?? 0,
                    schoolcountT13 ?? 0,
                    schoolcountT15 ?? 0,
                ));
            }
            return rows;
        }
    );

    const content: Row[] = [
        {
            cells: [
                {
                    value: '年級　/ 　性別 ',
                    merge: { column: 2 },
                    style: { border: fullBorderStyle },
                },
                {
                    value: '人數',
                    merge: { column: 1 },
                    style: { border: fullBorderStyle },
                },
                {
                    value: '未治療齲齒人數A',
                    merge: { column: 1 },
                    style: { border: fullBorderStyle },
                },
                {
                    value: '未治療齲齒比率％',
                    merge: { column: 1 },
                    style: { border: fullBorderStyle },
                },
                {
                    value: '已治療齲齒人數B',
                    merge: { column: 1 },
                    style: { border: fullBorderStyle },
                },
                {
                    value: '已治療齲齒比率％',
                    merge: { column: 1 },
                    style: { border: fullBorderStyle },
                },
                {
                    value: '上顎恆牙第一大臼齒齲齒經驗C',
                    merge: { column: 1 },
                    style: { border: fullBorderStyle },
                },
                {
                    value: '上顎恆牙第一大臼齒齲齒經驗％',
                    merge: { column: 1 },
                    style: { border: fullBorderStyle },
                },
                {
                    value: '下顎恆牙第一大臼齒齲齒經驗D',
                    merge: { column: 1 },
                    style: { border: fullBorderStyle },
                },
                {
                    value: '下顎恆牙第一大臼齒齲齒經驗％',
                    merge: { column: 1 },
                    style: { border: fullBorderStyle },
                },
                {
                    value: '恆牙臼齒窩溝封填E',
                    merge: { column: 1 },
                    style: { border: fullBorderStyle },
                },
                {
                    value: '恆牙臼齒窩溝封填％',
                    merge: { column: 1 },
                    style: { border: fullBorderStyle },
                },
            ],
        },
        ...contentRows,
    ];

    // const workSheet = generateSheet(content, { alignment: cellAlignStyle });
    const handlePrint = () => {
        const printWindow = window.open(
            '',
            '_blank',
            'width=1400,height=900'
        );

        if (!printWindow) {
            alert('瀏覽器阻擋了列印視窗，請允許彈出式視窗。');
            return;
        }

        const escapeHtml = (value: unknown): string => {
            return String(value ?? '')
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#039;');
        };

        const title =
            `${yearSem?.year}學年第${yearSem?.sem}學期_口腔檢查結果統計`;

        const tableRows = content
            .map((row) => {
                const cells = row.cells
                    .map((cell) => {
                        if (cell.value === undefined) {
                            return '';
                        }

                        const colSpan = cell.merge?.column
                            ? ` colspan="${cell.merge.column}"`
                            : '';

                        const rowSpan = cell.merge?.row
                            ? ` rowspan="${cell.merge.row}"`
                            : '';

                        return `
                        <td${colSpan}${rowSpan}>
                            ${escapeHtml(cell.value)}
                        </td>
                    `;
                    })
                    .join('');

                return `<tr>${cells}</tr>`;
            })
            .join('');

        printWindow.document.open();

        printWindow.document.write(`
        <!DOCTYPE html>
        <html lang="zh-Hant">
        <head>
            <meta charset="UTF-8" />

            <title>${escapeHtml(title)}</title>

            <style>
                * {
                    box-sizing: border-box;
                }

                html,
                body {
                    margin: 0;
                    padding: 0;
                    font-family:
                        "Microsoft JhengHei",
                        "Noto Sans TC",
                        Arial,
                        sans-serif;
                    color: #000;
                }

                .print-page {
                    min-height: 190mm;
                    display: flex;
                    flex-direction: column;
                }

                h1 {
                    margin: 0 0 8px;
                    text-align: center;
                    font-size: 16px;
                }

                .description {
                    margin-bottom: 3px;
                    font-size: 9px;
                }

                table {
                    width: 100%;
                    border-collapse: collapse;
                    table-layout: fixed;
                    margin-top: 8px;
                }

                td {
                    border: 1px solid #000;
                    padding: 3px 1px;
                    text-align: center;
                    vertical-align: middle;
                    font-size: 8px;
                    word-break: break-word;
                }

                .footer {
    margin-top: auto;
    padding-top: 16px;
    font-size: 12px;
    display: flex;
    justify-content: space-between;
    width: 100%;
}

                @page {
                    size: A4 landscape;
                    margin: 7mm;
                }

                @media print {
                    body {
                        padding: 0;
                    }

                    tr {
                        page-break-inside: avoid;
                        break-inside: avoid;
                    }
                }
            </style>
        </head>

        <body>
            <div class="print-page">

                <h1>${escapeHtml(title)}</h1>

                <div class="description">
                    一、A：未治療齲齒人數（未治療齲齒資料代號為 1、3）
                </div>

                <div class="description">
                    二、B：已治療齲齒人數（已治療齲齒資料代號為 1）
                </div>

                <div class="description">
                    三、C：上顎恆牙第一大臼齒齲齒經驗（上顎恆牙第一大臼齒齲齒經驗資料代號為 1）
                </div>

                <div class="description">
                    四、D：下顎恆牙第一大臼齒齲齒經驗（下顎恆牙第一大臼齒齲齒經驗資料代號為 1）
                </div>

                <div class="description">
                    五、E：恆牙臼齒窩溝封填（恆牙臼齒窩溝封填資料代號為 1）
                </div>

                <table>
                    <tbody>
                        ${tableRows}
                    </tbody>
                </table>

                 <div class="footer">
  <span>承辦人:</span>
  <span>組長:</span>
  <span>主任:</span>
  <span>校長:</span>
</div>

            </div>

            <script>
                window.onload = function () {
                    window.focus();

                    setTimeout(function () {
                        window.print();
                    }, 300);
                };

                window.onafterprint = function () {
                    window.close();
                };
            </script>
        </body>
        </html>
    `);

        printWindow.document.close();
    };

    return (
        <AuthedLayout>
            <BSRow className="justify-content-between">
                <span className="mr-3">{element}</span>
                {physicalGrades.length > 0 && (
                    <span style={{ color: 'red' }}>
                        ※ 提示：{physicalGrades.join('、')} 年級的資料來自健檢口腔資料
                    </span>
                )}
                <DropdownButton
                    id="tee-static-sex-all-export"
                    title="匯出"
                    variant="success"
                    disabled={!datas.length}
                >
                    <Dropdown.Item
                        onClick={() => {
                            const workSheet = generateSheet(
                                [
                                    {
                                        cells: [
                                            {
                                                value: `${yearSem?.year}學年第${yearSem?.sem}學期_口腔檢查結果統計`,
                                                style: { alignment: { horizontal: 'left' } },
                                            },
                                        ],
                                    },
                                    {
                                        cells: [
                                            {
                                                value: '一、A：未治療齲齒人數（未治療齲齒資料代號為 1、3）',
                                                merge: { column: 7 },
                                                style: { alignment: { horizontal: 'left' } },
                                            }
                                        ]
                                    },
                                    {
                                        cells: [
                                            {
                                                value: '二、B：已治療齲齒人數（已治療齲齒資料代號為 1）',
                                                merge: { column: 7 },
                                                style: { alignment: { horizontal: 'left' } },
                                            }
                                        ]
                                    },
                                    {
                                        cells: [
                                            {
                                                value: '三、C：上顎恆牙第一大臼齒齲齒經驗（上顎恆牙第一大臼齒齲齒經驗資料代號為 1）',
                                                merge: { column: 7 },
                                                style: { alignment: { horizontal: 'left' } },
                                            }
                                        ]
                                    },
                                    {
                                        cells: [
                                            {
                                                value: '四、D：下顎恆牙第一大臼齒齲齒經驗（下顎恆牙第一大臼齒齲齒經驗資料代號為 1）',
                                                merge: { column: 7 },
                                                style: { alignment: { horizontal: 'left' } },
                                            }
                                        ]
                                    },
                                    {
                                        cells: [
                                            {
                                                value: '五、E：恆牙臼齒窩溝封填（恆牙臼齒窩溝封填資料代號為 1）',
                                                merge: { column: 7 },
                                                style: { alignment: { horizontal: 'left' } },
                                            }
                                        ]
                                    },
                                    ...content,
                                    {
                                        cells: [
                                            {
                                                value:
                                                    '承辦人:　　　　　　　　　　　　　組長:　　　　　　　　　　　　　主任:　　　　　　　　　　　　　　校長:　　　　　　　　　　　　',
                                                style: { alignment: { horizontal: 'left' } },
                                            },
                                        ],
                                    },
                                ],
                                {
                                    alignment: cellAlignStyle,
                                }
                            );

                            downloadSheets(
                                '口腔檢查結果統計',
                                userinfo?.exportFileType,
                                {
                                    sheet: workSheet,
                                    name: 'st'
                                }
                            );
                        }}
                    >
                        Excel 下載
                    </Dropdown.Item>

                    <Dropdown.Item onClick={handlePrint}>
                        列印
                    </Dropdown.Item>
                </DropdownButton>
            </BSRow>
            <hr />
            <BSRow>
                <Table
                    striped
                    bordered
                    className="text-center"
                    style={{ tableLayout: 'fixed' }}
                >
                    <colgroup>
                        <col style={{ width: '4%' }} />
                        <col style={{ width: '4%' }} />
                        <col style={{ width: '5%' }} />
                        <col style={{ width: '7%' }} />
                        <col style={{ width: '7%' }} />
                        <col style={{ width: '7%' }} />
                        <col style={{ width: '7%' }} />
                        <col style={{ width: '7%' }} />
                        <col style={{ width: '7%' }} />
                        <col style={{ width: '7%' }} />
                        <col style={{ width: '7%' }} />
                        <col style={{ width: '7%' }} />
                        <col style={{ width: '7%' }} />
                    </colgroup>
                    <tbody>
                        {content.map((r, i) => {
                            const cells = r.cells.map((c, j) =>
                                c.value != undefined ? (
                                    <td
                                        colSpan={c.merge?.column}
                                        rowSpan={c.merge?.row}
                                        key={`${i}-${j}`}
                                    >
                                        {c.value}
                                    </td>
                                ) : (
                                    <Fragment key={`${i}-${j}`}></Fragment>
                                )
                            );
                            return <tr key={i}>{cells}</tr>;
                        })}
                    </tbody>
                </Table>
            </BSRow>
        </AuthedLayout>
    );
};

function TeeToRows(
    grade: number,
    maleCount: number,
    maleCountT01: number,
    maleCountT11: number,
    maleCountT12: number,
    maleCountT13: number,
    maleCountT15: number,
    femaleCount: number,
    femaleCountT01: number,
    femaleCountT11: number,
    femaleCountT12: number,
    femaleCountT13: number,
    femaleCountT15: number,
    totalCount: number,
    totalCountT01: number,
    totalCountT11: number,
    totalCountT12: number,
    totalCountT13: number,
    totalCountT15: number,
): Row[] {
    let returnhtml;
    const gradeNo = [
        {
            value: grade,
            merge: { row: 3 },
            style: { border: fullBorderStyle },
        }
    ];
    if (grade != 0) {
        returnhtml = [
            {
                cells: [
                    ...gradeNo,
                    {
                        value: "男",
                        merge: { row: 1 }
                    },
                    {
                        value: maleCount,
                    },
                    {
                        value: maleCountT01,
                    },
                    {
                        value: percent(maleCountT01, maleCount),
                    },
                    {
                        value: maleCountT11,
                    },
                    {
                        value: percent(maleCountT11, maleCount),
                    },
                    {
                        value: maleCountT12,
                    },
                    {
                        value: percent(maleCountT12, maleCount),
                    },
                    {
                        value: maleCountT13,
                    },
                    {
                        value: percent(maleCountT13, maleCount),
                    },
                    {
                        value: maleCountT15,
                    },
                    {
                        value: percent(maleCountT15, maleCount),
                    },
                ],

            },
            {
                cells: [
                    {
                        style: { border: fullBorderStyle },
                    },
                    {
                        value: "女",
                        merge: { row: 1 }
                    },
                    {
                        value: femaleCount,
                    },
                    {
                        value: femaleCountT01,
                    },
                    {
                        value: percent(femaleCountT01, femaleCount),
                    },
                    {
                        value: femaleCountT11,
                    },
                    {
                        value: percent(femaleCountT11, femaleCount),
                    },
                    {
                        value: femaleCountT12,
                    },
                    {
                        value: percent(femaleCountT12, femaleCount),
                    },
                    {
                        value: femaleCountT13,
                    },
                    {
                        value: percent(femaleCountT13, femaleCount),
                    },
                    {
                        value: femaleCountT15,
                    },
                    {
                        value: percent(femaleCountT15, femaleCount),
                    },
                ],

            },
            {
                cells: [
                    {
                        style: { border: fullBorderStyle },
                    },
                    {
                        value: "小計",
                        merge: { row: 1 }
                    },
                    {
                        value: totalCount,
                    },
                    {
                        value: totalCountT01,
                    },
                    {
                        value: percent(totalCountT01, totalCount)
                    },
                    {
                        value: totalCountT11,
                    },
                    {
                        value: percent(totalCountT11, totalCount)
                    },
                    {
                        value: totalCountT12,
                    },
                    {
                        value: percent(totalCountT12, totalCount)
                    },
                    {
                        value: totalCountT13,
                    },
                    {
                        value: percent(totalCountT13, totalCount)
                    },
                    {
                        value: totalCountT15,
                    },
                    {
                        value: percent(totalCountT15, totalCount)
                    },
                ],

            },
        ]
    } else {
        returnhtml = [
            {
                cells: [
                    {
                        value: "總計",
                        merge: { column: 2 }
                    },
                    {
                        value: totalCount,
                    },
                    {
                        value: totalCountT01,
                    },
                    {
                        value: percent(totalCountT01, totalCount)
                    },
                    {
                        value: totalCountT11,
                    },
                    {
                        value: percent(totalCountT11, totalCount)
                    },
                    {
                        value: totalCountT12,
                    },
                    {
                        value: percent(totalCountT12, totalCount)
                    },
                    {
                        value: totalCountT13,
                    },
                    {
                        value: percent(totalCountT13, totalCount)
                    },
                    {
                        value: totalCountT15,
                    },
                    {
                        value: percent(totalCountT15, totalCount)
                    },
                ],

            },

        ]
    }
    return returnhtml;
}

function percent(value: number, denominator: number): string {
    if (!denominator) return '0.00%';
    return ((value / denominator) * 100).toFixed(2) + '%';
}
export const TeeStaticSexAll = connector(teeStaticSexAll);
